import React, { Component } from 'react';

class Error extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        return (

                <div className='error_explanation'>
                    <h2>{this.props.message}</h2>
                </div>

        )
    }
}

export default Error